var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296.78 250.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dc3027;}.cls-2{fill:#921b1e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    className: "cls-1",
    d: "M261.59,86.68a39.3,39.3,0,0,0-31.38-15.43,40.75,40.75,0,0,0-31.86,15.31,55.53,55.53,0,0,0-11.91,35.32c0,28.94,22.3,43,30.7,48.31a21.32,21.32,0,0,0,26.41-.17c.26-.18.6-.4,1-.65A69.78,69.78,0,0,0,261,155.06,51.07,51.07,0,0,0,272.87,122v-.07C272.86,108.4,268.85,95.9,261.59,86.68ZM237,157.79c-.51.32-.94.61-1.27.84a11.88,11.88,0,0,1-5.51,2.24,12.11,12.11,0,0,1-5.7-2.37c-12-7.57-24.25-17.82-24.25-36.62,0-21,12.87-36.8,29.94-36.8a25.55,25.55,0,0,1,21.51,11.54A44.74,44.74,0,0,1,259,121.9c0,19.25-12.57,29.7-22.05,35.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    className: "cls-1",
    d: "M295.34,214.17c-3.9-5.44-21.17-28.78-33-32.12-9.91-2.78-22.32.47-29,2.21-.9.24-1.66.45-2.24.58l-1.07-.3-.61.26-2.43-.6c-9.55-2.4-20.35-4.72-27.57-2-5.54,2.11-12.29,8.36-18.23,14.86-1.58,1.74-3.12,3.5-4.54,5.2-1.6,1.88-3.07,3.7-4.37,5.33a208.77,208.77,0,0,1,15.63,16.55H290.76a6,6,0,0,0,5.7-4.08A6.12,6.12,0,0,0,295.34,214.17ZM182.24,213c.77-1,1.56-1.91,2.37-2.87,1.49-1.78,3-3.55,4.56-5.24,5.42-6,10.82-11,14.22-12.31,4.53-1.73,16,1.14,20.91,2.38a20.87,20.87,0,0,0,6.37,1.08,19.6,19.6,0,0,0,5.52-1c5.24-1.38,16.17-4.25,23.13-2.27,4.73,1.32,13.81,11,21.2,20.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    className: "cls-2",
    d: "M157.54,24.25A61.67,61.67,0,0,0,108.33,0a64.06,64.06,0,0,0-50,24.12c-12.27,14.89-19,35-19,56.54a78.78,78.78,0,0,0,17.87,50.77c9.86,12.16,22.1,20.65,31.69,26.69,7.23,4.55,13.78,6.87,19.51,6.87,8.63,0,16.73-4.93,19.81-7,.47-.33,1.08-.72,1.78-1.18a112.65,112.65,0,0,0,26.72-23.15,81.59,81.59,0,0,0,18.9-52.85v-.12C175.53,59,169.13,39,157.54,24.25ZM122.38,145.19c-.83.54-1.52,1-2.06,1.37a23.64,23.64,0,0,1-12,4.61c-2.11,0-5.92-.82-12.13-4.73C74.88,133,53.09,114.67,53.09,80.68c0-38.11,23.75-66.84,55.24-66.84a48.18,48.18,0,0,1,38.26,18.89c9.49,11.87,15.11,28.58,15.12,48C161.75,119.49,132.11,138.83,122.38,145.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    className: "cls-2",
    d: "M210.91,242.28s-5.86-8.22-14-18.12c-3-3.6-6.23-7.4-9.62-11.12-.89-1-1.78-1.93-2.67-2.87-2.63-2.78-5.32-5.45-8-7.88-6-5.49-11.84-9.74-16.68-11.1-19.41-5.49-48.57,6-50.85,5.21a1,1,0,0,0-.74,0c-2,.85-34.13-10.72-48.62-5.22-18.24,6.94-50.22,51.08-50.22,51.08-.61.47-3.25,1.51-2.5,1.51H210.46a.84.84,0,0,0,.78-.9A.86.86,0,0,0,210.91,242.28ZM22.3,236.87c12.53-15.93,30.12-35.48,39.92-39.2,8.41-3.2,27.56,1.6,36.76,3.9,5.46,1.37,8,2,10,1.78,1.94.11,4.29-.52,8.8-1.7,9.75-2.55,27.91-7.32,40.3-3.81,3.75,1,8.74,4.71,14.21,9.77a207.06,207.06,0,0,1,15.63,16.55c3.63,4.25,7.16,8.58,10.35,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    className: "cls-2",
    d: "M216.24,237.86c-1.09-1.52-5-6.9-10.43-13.7-2.49-3.1-5.31-6.52-8.31-10l-1-1.11q-3.81-4.41-7.37-8.11-4.18-4.41-8-7.85c-7.53-6.88-13.92-11-19.36-12.55-16-4.53-36.55.85-47.58,3.74-1.76.47-3.73,1-4.72,1.2a7.52,7.52,0,0,0-1.71,0c-1.14-.23-3.43-.8-5.51-1.32-15.75-3.94-33.53-7.78-45-3.42-18.37,7-46.21,43.76-52.42,52.19-.35.17-.69.34-.94.48a7.12,7.12,0,0,0-3.76,7.89A7,7,0,0,0,7,250.69H210.45a7.75,7.75,0,0,0,5.79-12.83Zm-194-1c12.54-15.93,30.13-35.48,39.92-39.2,8.41-3.2,27.57,1.6,36.77,3.9,5.45,1.37,8,2,10,1.79,1.94.1,4.28-.53,8.79-1.71,9.75-2.55,27.91-7.32,40.31-3.81,3.75,1,8.74,4.72,14.2,9.77a210.75,210.75,0,0,1,15.64,16.55c3.63,4.25,7.15,8.59,10.35,12.71Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img_2.d3d469c145780940c30c6501631aaee0.svg";
export { ForwardRef as ReactComponent };